/** @copyright (c) Viewpost. All Rights Reserved. See LICENSE for more details. */

export const isPathConfig = obj => !!(obj || {}).toPath;
